// DeltaGain brand palette (matches deltagain.co.uk: deep plum header/hero, orchid accent)
export const DELTA_PRIMARY = "#3D1E45";
export const DELTA_PRIMARY_DARK = "#2A1430";
export const DELTA_ACCENT = "#8E3B93";
export const DELTA_ACCENT_LIGHT = "#B565BA";

export const PAPER_GREY = "#F5F5F7";
export const BORDER_GREY = "#E2E2E7";
export const TEXT_SECONDARY = "#5C5C66";

export const STATUS_GREEN = "#2E7D32";
export const STATUS_RED = "#C62828";
export const STATUS_AMBER = "#B8860B";
export const STATUS_GREY = "#78788C";

// Was gold, but that's identical to STATUS_AMBER (warning/partial) - now that
// the app uses red/amber/green for status pills, PRO needs its own identity
// clearly outside that vocabulary (and outside the brand purple used for
// nav/links/selected states) so it doesn't borrow meaning from either.
export const PRO_INDIGO = "#1A237E";

// Enterprise sits a tier above PRO - a deep teal reads as distinctly "more
// premium" without colliding with PRO_INDIGO, the status green/amber/red
// vocabulary, or the brand purple.
export const ENTERPRISE_TEAL = "#004D40";
